<template>
  <div>
    <app-breadcrumb />
    <div class="card mb-1">
      <div class="card-body p-1">
        <div class="row">
          <div class="col-12 col-md-2">
            <b-form-group label="Kỳ thống kê"
              class="mb-0">
              <v-select v-model="thongke"
                :options="dataThongke"
                label="name"
                :reduce="(val) => val.id"
                placeholder="--Chọn--" />
            </b-form-group>
          </div>
          <div class="col-12 col-md-2">
            <b-form-group v-if="thongke == 2">
              <template #label>
                <label class="d-block font-weight-bolder pb-0"><strong>Từ ngày</strong></label>
              </template>
              <flat-pickr v-model="start_date"
                :value="start_date"
                class="form-control"
                :config="config_date"
                placeholder="dd-mm-yyyy" />
            </b-form-group>
            <b-form-group v-else
              label="Năm"
              class="mb-0">
              <v-select v-model="year"
                :options="dataYear"
                label="name"
                :reduce="(val) => val.id"
                placeholder="--Chọn--" />
            </b-form-group>
          </div>
          <div class="col-12 col-md-2">
            <b-form-group v-if="thongke == 2">
              <template #label>
                <label class="d-block font-weight-bolder pb-0"><strong>Đến ngày</strong></label>
              </template>
              <flat-pickr v-model="end_date"
                :value="end_date"
                class="form-control"
                :config="config_date"
                placeholder="dd-mm-yyyy" />
            </b-form-group>
            <b-form-group v-else
              label="Tháng"
              class="mb-0">
              <v-select v-model="month"
                :options="dataMonth"
                label="name"
                :reduce="(val) => val.id"
                placeholder="--Chọn--" />
            </b-form-group>
          </div>
          <div class="sol-12 col-md-2">
            <div style="padding-top: 2rem">
              <b-button variant="danger"
                @click="updateSearchQuery">
                <feather-icon icon="SearchIcon" /> Tìm kiếm </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- List -->
    <b-overlay :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm">
      <b-card no-body
        class="mb-0">
        <b-table ref="refListTable"
          :items="dataItems"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching records found">
        </b-table>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import {
  BCard,
  BOverlay,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BFormCheckbox,
  BPagination,
  BInputGroupAppend,
  BInputGroup,
  BFormGroup,
  BLink,
} from 'bootstrap-vue';
import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import { showToast } from '@/@core/utils/utils';
export default {
  components: {
    BOverlay,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BInputGroupAppend,
    AppBreadcrumb,
    BInputGroup,
    BFormCheckbox,
    BFormGroup,
    BLink,
    vSelect,
    flatPickr
  },
  data() {
    return {
      dataThongke: [
        { id: 1, name: 'Tháng' },
        { id: 2, name: 'Khoảng thời gian' },
      ],
      dataMonth: [
        { id: 1, name: 'Tháng 1' },
        { id: 2, name: 'Tháng 2' },
        { id: 3, name: 'Tháng 3' },
        { id: 4, name: 'Tháng 4' },
        { id: 5, name: 'Tháng 5' },
        { id: 6, name: 'Tháng 6' },
        { id: 7, name: 'Tháng 7' },
        { id: 8, name: 'Tháng 8' },
        { id: 9, name: 'Tháng 9' },
        { id: 10, name: 'Tháng 10' },
        { id: 11, name: 'Tháng 11' },
        { id: 12, name: 'Tháng 12' },
      ],
    }
  },
  setup() {
    const refListTable = ref(null);
    const tableColumns = [
      { key: 'name', sortable: false, label: 'Thể loại' },
      { key: 'manual', label: 'Thu bằng tay', thAttr: { width: '20%' }, class: 'text-center', },
      { key: 'auto', label: 'Thu theo lịch có sẵn', thAttr: { width: '20%' }, class: 'text-center', },
    ];
    let currentYear = new Date().getFullYear();
    const perPage = ref(30);
    const total = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref('');
    const localSearchQuery = ref('');
    const loading = ref(true);
    const dataItems = ref([]);
    const dataParent = ref([])
    const thongke = ref(1);
    const year = ref('')
    const start_date = ref('');
    const end_date = ref('')
    const month = ref('')
    const fetchAll = () => {
      store
        .dispatch('channel/fetchall', {
          keyword: searchQuery.value,
          perPage: perPage.value,
          page: currentPage.value,
          card_type: 'channel_statistic',
          start_date: start_date.value,
          end_date: end_date.value,
          thongke: thongke.value,
          year: year.value,
          month: month.value
        })
        .then((response) => {
          loading.value = false;
          let result = response.data;

          if (result.code === 200) {
            dataItems.value = result.data.data;
          }
        });
    };
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value
        ? refListTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      };
    });
    fetchAll();
    watch([currentPage, perPage, searchQuery], () => {
      refetchData();
    });

    const refetchData = () => {
      fetchAll();
    };

    const updateSearchQuery = () => {
      if (start_date.value && start_date.value > end_date.value) {
        showToast('Đến ngày phải lớn hơn từ ngày')
        return false;
      }

      if (thongke.value == 1 && year.value == '') {
        showToast('Cần chọn năm trước khi gửi tìm kiếm')
        return false;
      } else if (thongke.value == 2 && (start_date.value == '' && end_date.value == '')) {
        showToast('Cần chọn từ ngày, đến ngày trước khi gửi tìm kiếm')
        return false;
      }
      refetchData();
    };
    const config_date = ref({
      dateFormat: 'd-m-Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });


    let dataYear = ref([{ id: currentYear, name: currentYear }]);
    for (let i = 1; i < 10; i++) {
      let text = currentYear - i;
      dataYear.value.push({ id: text, name: text });
    }
    return {
      loading,
      dataItems,
      perPage,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      refListTable,
      refetchData,
      updateSearchQuery,
      localSearchQuery,
      dataParent,
      thongke,
      config_date,
      dataYear,
      start_date,
      end_date,
      year,
      month
    };
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>